module.exports = __webpack_public_path__ + "img/collection-weddingRingsRosegold@2x.881eae0.jpg";